import * as React from 'react';
import '@styles/pages/tab2.scss';
import { StageDefault, StageCurrent } from '@/context.ts';
import SideBar from '@hook/public/sideBar.tsx';
import { fetch, AreaConfigRsp, AreaInfo } from '@/fetch.ts';
import banner from '@images/banner.png';
import Hour from '@hook/public/hour.tsx';
import Tab1Rank from '@hook/Tab1/rank.tsx';
import Tab2Rank3 from '@hook/Tab2/rank3.tsx';
import Tab2Rank4 from '@hook/Tab2/rank4.tsx';

const { useState, useEffect, useContext } = React;

interface TabsType {
  current: number,
  title: string,
  time: string,
  tips: string,
}
const tabs: TabsType[] = [
  {
    current: 0,
    title: '复活赛',
    time: '8.08-8.11',
    tips: '各阶段淘汰主播进入复活赛，复活赛第一直接晋级决赛',
  },
  {
    current: 1,
    title: '30进12',
    time: '8.08-8.09',
    tips: '提升热度，争夺淘汰赛名额',
  },
  {
    current: 2,
    title: '12进6',
    time: '8.10',
    tips: '主播随机1V1对阵，胜者晋级下一阶段',
  },
  {
    current: 3,
    title: '6进3',
    time: '8.11',
    tips: '胜者晋级决赛，败者中热度最高者亦可晋级',
  },
  {
    current: 4,
    title: '决赛',
    time: '8.12',
    tips: '提升热度，角逐分区冠军！',
  },
]

const Tab2: React.FC<void> = () => {
  const [stage, Stage] = useState<number>(-1);
  const {iStage, tabToastOpen} = useContext(StageDefault);
  useEffect(() => {
    Stage(iStage);
  }, [])
  const [list, List] = useState<AreaInfo[]>([]);
  const [showHover, ShowHover] = useState<number>(-1);
  useEffect(() => {
    /* 获取所有分区 */
    fetch.getAreaConfig(
      {
        iMatchId: 2,
      },
    )
      .then((rsp: AreaConfigRsp) => {
        List(rsp.vAreaList.value);
      })
  }, [])
  return (
    <StageCurrent.Provider
      value={{current: stage}}
    >
      <div className='tab2'>
        <SideBar list={list} showHour={(iStage === 4 && stage === 0) ? false : true}  />
        <div className='tab2tab'>
          <div className='tabline'>
            {
              tabs.map((item: TabsType) => (
                <div
                  className={stage === item.current ? 'tab2item on' : 'tab2item'}
                  key={item.current}
                  onClick={
                    (): void => {
                      if (item.current > iStage) {
                        tabToastOpen('该阶段暂未开启~');
                      } else {
                        Stage(item.current);
                      }
                    }
                  }
                  onMouseEnter={
                    (): void => {
                      ShowHover(item.current);
                    }
                  }
                  onMouseLeave={
                    ():void => {
                      ShowHover(-1);
                    }
                  }
                >
                  <h2>{item.title}</h2>
                  <i></i>
                  <p>{item.time}</p>
                  {
                    showHover !== -1 && showHover === item.current &&
                    <div className='hover'>
                      <p>{tabs[showHover].tips}</p>
                    </div>
                  }
                </div>
              ))
            }
          </div>
        </div>
        {
          (iStage === 4 && stage === 0) ? '' : <Hour />
        }
        <section className='ranklist'>
          {
            list.map((item: AreaInfo) => {
              const COMP = [Tab1Rank, Tab1Rank, Tab2Rank3, Tab2Rank3, Tab2Rank4][stage];
              return <COMP key={(stage + 1) + item.iArea + 2} {...item} revive={stage === 0} haixuan={stage === 1} />
            })
          }
        </section>
      </div>
    </StageCurrent.Provider>
  );
}

export default Tab2;